// CHG-0136 (MacKenzie 10/29, Bill 11/2: fix): the Review tile lists only the services the customer chose, once each.
// It mirrors what commit sends to Core (CartCommitService), so Review never shows a service that won't be set up.

/** Bookkeeping keys stored beside a service: the card owners, designs and opt-outs belong to the debit card. */
const HIDDEN_KEYS = new Set(['fundingMethod', 'fundingDeadline', 'debitCardOwners', 'debitCardDesigns', 'debitCardOptOut']);

function humanizeFeatureCode(code: string): string {
  const c = code.toLowerCase().replace(/[^a-z0-9]/g, '');
  if (c.includes('debit')) return 'Debit card';
  if (c.includes('check')) return 'Check order';
  if (c.includes('stmt') || c.includes('statement')) return 'e-Statements';
  if (c.includes('internet') || c === 'ib') return 'Internet banking';
  if (c.includes('overdraft') || c === 'od') return 'Overdraft protection';
  return code;
}

function isOn(v: unknown): boolean {
  return v === true || (v != null && typeof v === 'object') || (typeof v === 'string' && v.length > 0);
}

/** Same test as commit's FlagOn: true, or the strings true / Y / yes. */
function flagOn(v: unknown): boolean {
  if (v === true) return true;
  return typeof v === 'string' && ['true', 'y', 'yes'].includes(v.trim().toLowerCase());
}

export function reviewFeatureLabels(fv: Record<string, unknown>): string[] {
  const labels: string[] = [];
  for (const [key, value] of Object.entries(fv)) {
    if (HIDDEN_KEYS.has(key) || !isOn(value)) continue;
    // Declined by the customer, or not offered by the officer: commit zeroes the limit (REQ-184).
    if (key === 'overdraftProtection' && value && typeof value === 'object') {
      const status = (value as Record<string, unknown>)['odpStatus'];
      if (typeof status === 'string' && ['declined', 'revoked'].includes(status.trim().toLowerCase())) continue;
    }
    // e-Statements ride the internet-banking enrollment; without it commit sends none (MacKenzie 7/20, Bill 7/24).
    if ((key === 'electronicStatements' || key === 'eStatements')
      && !flagOn(fv['internetBanking']) && !flagOn(fv['internetBankingEnroll'])) continue;
    const label = humanizeFeatureCode(key);
    if (!labels.includes(label)) labels.push(label);
  }
  return labels;
}
